// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "mapbox" + "." + "1d98a5b3a4a3946f9ef1" + ".css";
};